import React from "react";
import { MdArrowForward } from "react-icons/md";
import { MdOutlineCalendarMonth } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import aidynamic from "./../Assets/Icons/aiDynamic.svg";
import bigfive from "./../Assets/Icons/bigFive.svg";
import { Tabs } from "antd";
import { isEmpty } from "lodash";
import { useGetAssessmentList } from "../Hooks/AssesmentHooks";

const AssesmentReview = () => {
  const navigate = useNavigate();
  const { data: reportsData } = useGetAssessmentList({
    params: {},
  });

  console.log(reportsData, "reportsDatareportsData");

  const reports = [
    {
      id: 1,
      title: "AI Dynamic Interview",
      attendedDate: "18-09-2025",
      image: aidynamic,
      interview_type: "RESUME_ASSESSMENT",
    },
    {
      id: 2,
      title: "Big Five Personality Test",
      attendedDate: "20-09-2025",
      image: bigfive,
      interview_type: "PERSONALITY",
    },
  ];
  return (
    <div className="w-full  h-[700px] bg-white shadow-lg rounded-xl p-6 sm:p-8 overflow-y-auto mt-4">
      {isEmpty(reportsData?.data?.results) ? (
        <p className="text-center text-gray-500">No Assessments Available</p>
      ) : (
        reportsData?.data?.results?.map((report) => (
          <div
            key={report.id}
            className="flex flex-col items-start justify-between p-4 mb-4 bg-white border-b rounded-lg sm:flex-row sm:items-center sm:p-6 last:mb-0"
          >
            <div className="flex items-center gap-4 mb-2 sm:mb-0">
              <img
                src={
                  report.interview_method === "PERSONALITY" ? bigfive : aidynamic
                }
                alt={report.title}
                className="flex-shrink-0 object-cover w-12 h-12 rounded-full"
              />
              <div>
                <p className="text-base font-semibold text-gray-800 sm:text-lg">
                  {report.title}
                </p>
                <p className="flex items-center gap-2 text-xs text-gray-500">
                  <MdOutlineCalendarMonth size={12} />
                  Attended Date {report.attendedDate}
                </p>
              </div>
            </div>

            <button
              className="text-[#0071DC] text-sm font-medium hover:text-blue-800 flex items-center gap-1 mt-2 sm:mt-0"
              onClick={() => {
                report?.interview_method === "PERSONALITY"
                  ? navigate(`/preview-big5/${report.id}/`)
                  : navigate(`/preview-assesment/${report.id}/`);
              }}
            >
              View Result <MdArrowForward size={16} />
            </button>
          </div>
        ))
      )}
    </div>
  );
};
export default AssesmentReview;
